export default "__VITE_ASSET__DqPTHYSE__"